export default function Loading( { url = "" }){
    return(
        <div className = "page" style = { { height : "100vh", display : "flex", flexDirection : "column", alignItems : "center", justifyContent : "center" } }>
            <p className = "meta">WORKING ON IT..</p>
            
            {/* <img src = "/loading.gif" style = { { width : "200px", height : "auto" } }/> */}

            <br/>
            <p className = "meta" style={{ fontSize: "var(--font-size-teeny)" }}>Notion server is taking a while..</p>

            { url !== "" && 
            <div style = { { display : "flex", flexDirection : "column", alignItems : "center", gap : "8px" } }>
                <p className = "meta" style={{ fontSize: "var(--font-size-teeny)" }}>If it's taking too long, please visit the below link. Sorry about the inconvenience!</p>

                <a className = "a" href = { url } target = "_blank" rel = "noreferrer" style = { { fontSize : "var(--font-size-teeny)", padding : "4px 8px", background : "black", color : "white", borderRadius : "4px" } }>
                    View on Notion
                </a>            
            </div>
            }

        </div>
    )
}